import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import type { ICurrencyAlertData, ICurrencyInfoData } from '~/types/deposit';

export const useStoreModalDeposit = defineStore('depositModal', {
  state: () => ({
    title: '',
    minDepositTitle: '',
    qrText: '',
    noBonusesTitle: '',
    currencyAlert: [] as ICurrencyAlertData[],
    currencyInfo: [] as ICurrencyInfoData[],
    step2Title: '',
    currencyTitle: '',
    amountTitle: '',
    yourBalance: '',
    displayCryptoInFiat: '',
    addNewCurrency: '',
    availableBonusTitle: '',
    enterBonusCodeTitle: '',
    bonusConditionsTitle: '',
    youCreditCardsTitle: '',
    recomended: '',
    min: '',
    savedCardsLimitMaxInfo: '',
    noBonusesAvailableText: '',
    noBonusCodeNeededText: '',
    minDepositForBonusText: '',
    tagName: '',
    confirmRemoveCardTitle: '',
    confirmRemoveCardText: '',
    coolingOffErrorText: '',
    activeLimitErrorText: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),
  getters: {
    data(state) {
      return state;
    },
  },
  actions: {
    async loadDepositModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'currencyAlert',
          'currencyAlert.alertIcon',
          'currencyInfo',
        ]);

        this.requestPromise = strapi()
          .get('deposit-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        Object.keys(response.data).forEach((key) => {
          // @ts-ignore
          if (response.data[key]) {
            switch (key) {
              case 'currencyAlert':
                this[key] =
                  // @ts-ignore
                  response.data[key]?.map((item) => {
                    return {
                      alertCurrency: item?.alertCurrency ?? '',
                      id: Number(item?.id),
                      alertMessage: item?.alertMessage ?? '',
                    };
                  }) || [];
                break;
              default:
                // @ts-ignore
                this[key] = response.data[key];
            }
          }
        });
        return true;
      } else {
        return false;
      }
    },
  },
});
